import Vue from "vue";
import Router from "vue-router";
import home from "./../components/home.vue";
import enter from "./../components/enter.vue";
import demo from "../components/demo.vue";


import { getUrlCode, getHref } from "../util/index";
import store from '../store/index'

const vm = new Vue();

Vue.use(Router);

// const path = require('path')
// const files = require.context('@/components', false, /\.vue$/)
// console.log(files.keys())
const route = new Router({
  mode: "hash",
  routes: [
    { 
      path: "/", 
      name: "/", 
      component: home,
    },
    { path: "/index", name: "/index", component: home },
    { path: "/enter", name: "/enter", component: enter },
    { path: "/demo", name: "/demo", component: demo },
    // 
    {
      path: "/OrderDetails",
      name: "OrderDetails",
      component: () => import("../components/home/one/details.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/TaskDetails",
      name: "TaskDetails",
      component: () => import("../components/home/two/details.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/SignOnDetails",
      name: "SignOnDetails",
      component: () => import("../components/home/three/details.vue"),
      meta: {
        auth: true
      }
    },
    // 新建工单
    {
      path: "/newWorkOrder",
      name: "newWorkOrder",
      component: () => import("../components/home/pages/newWorkOrder.vue"),
      meta: {
        auth: true
      }
    },
    // 工序
    {
      path: "/process",
      name: "process",
      component: () => import("../components/home/pages/process.vue"),
      meta: {
        auth: true
      }
    },
    // 入库单
    {
      path: "/warehouseEntry",
      name: "warehouseEntry",
      component: () => import("../components/home/pages/warehouseEntry.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/entryDetails",
      name: "entryDetails",
      component: () => import("../components/home/pages/warehouseEntry/details.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/entryAdd",
      name: "entryAdd",
      component: () => import("../components/home/pages/warehouseEntry/add.vue"),
      meta: {
        auth: true
      }
    },
    // 出库单
    {
      path: "/warehouseOrder",
      name: "warehouseOrder",
      component: () => import("../components/home/pages/warehouseOrder.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/orderDetail",
      name: "orderDetail",
      component: () => import("../components/home/pages/warehouseOrder/details.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/orderAdd",
      name: "orderAdd",
      component: () => import("../components/home/pages/warehouseOrder/add.vue"),
      meta: {
        auth: true
      }
    },
    // 现有库存
    {
      path: "/stockQuantity",
      name: "stockQuantity",
      component: () => import("../components/home/pages/stockQuantity.vue"),
      meta: {
        auth: true
      }
    },
    // 产品数据
    {
      path: "/productData",
      name: "productData",
      component: () => import("../components/home/pages/productData.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/productAdd",
      name: "productAdd",
      component: () => import("../components/home/pages/productData/add.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/setBom",
      name: "setBom",
      component: () => import("../components/home/pages/productData/setBom.vue"),
      meta: {
        auth: true
      }
    },
    // 产品单位
    {
      path: "/unit",
      name: "unit",
      component: () => import("../components/home/pages/unit.vue"),
      meta: {
        auth: true
      }
    },
    // 不良品项
    {
      path: "/defectives",
      name: "defectives",
      component: () => import("../components/home/pages/defectives.vue"),
      meta: {
        auth: true
      }
    },
    // 绩效工资
    {
      path: "/allocation",
      name: "allocation",
      component: () => import("../components/home/pages/allocation.vue"),
      meta: {
        auth: true
      }
    },
    {
      path: "/allocationAdd",
      name: "allocationAdd",
      component: () => import("../components/home/pages/allocation/add.vue"),
      meta: {
        auth: true
      }
    },
    // 生产报表
    {
      path: "/productionReport",
      name: "productionReport",
      component: () => import("../components/home/pages/productionReport.vue"),
      meta: {
        auth: true
      }
    },
    // 客户列表
    {
      path: "/customerList",
      name: "customerList",
      component: () => import("../components/home/pages/customerList.vue"),
      meta: {
        auth: true
      }
    },
    // 供应商
    {
      path: "/suppliers",
      name: "suppliers",
      component: () => import("../components/home/pages/suppliers.vue"),
      meta: {
        auth: true
      }
    },


    // 
    // {
    //   path: "/daolujiuyuan",
    //   name: "/daolujiuyuan",
    //   component: () => import("../components/daolujiuyuan.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/xiaofeijilu",
    //   name: "/xiaofeijilu",
    //   component: () => import("../components/xiaofeijilu.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/taocanxiangmu",
    //   name: "/taocanxiangmu",
    //   component: () => import("../components/taocanxiangmu.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/zaixianyuyue",
    //   name: "/zaixianyuyue",
    //   component: () => import("../components/zaixianyuyue.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/yuyuedingdan",
    //   name: "/yuyuedingdan",
    //   component: () => import("../components/yuyuedingdan.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/jifenshangcheng",
    //   name: "/jifenshangcheng",
    //   component: () => import("../components/jifenshangcheng.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/store",
    //   name: "/store",
    //   component: () => import("../components/store.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/shiyongmendian",
    //   name: "/shiyongmendian",
    //   component: () => import("../components/shiyongmendian.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/yuyue",
    //   name: "/yuyue",
    //   component: () => import("../components/yuyue.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },

    // {
    //   path: "/youhuiquan",
    //   name: "/youhuiquan",
    //   component: () => import("../components/youhuiquan.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/bandinfo",
    //   name: "/bandinfo",
    //   component: () => import("../components/bandinfo.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: '/projectdetails', 
    //   name: '/projectdetails', 
    //   component: () => import('./../components/projectdetails.vue'),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: '/wodeyuyue', 
    //   name: '/wodeyuyue', 
    //   component: () => import('./../components/wodeyuyue.vue'),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: '/yuyuedetails', 
    //   name: '/yuyuedetails', 
    //   component: () => import('./../components/yuyuedetails.vue'),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/huiyuanka",
    //   name: "/huiyuanka",
    //   component: () => import("../components/huiyuanka.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/taocanzhifu",
    //   name: "/taocanzhifu",
    //   component: () => import("../components/taocanzhifu.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/huiyuanchongzhi",
    //   name: "/huiyuanchongzhi",
    //   component: () => import("../components/huiyuanchongzhi.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/marketingList",
    //   name: "/marketingList",
    //   component: () => import("../components/Marketing/index.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/marketing",
    //   name: "/marketing",
    //   component: () => import("../components/Marketing/marketing.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/storedetail",
    //   name: "/storedetail",
    //   component: () => import("../components/Storedetail.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/shareholder",
    //   name: "/shareholder",
    //   component: () => import("../components/shareholder.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/mymember",
    //   name: "/mymember",
    //   component: () => import("../components/shareholder/MyMember.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/gudongqrcode",
    //   name: "/gudongqrcode",
    //   component: () => import("../components/shareholder/gudongqrcode.vue"),
    //   meta: { auth: true }
    // },
    // {
    //   path: "/fenxiao",
    //   name: "/fenxiao",
    //   component: () => import("../components/shareholder/fenxiao.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/qrcode",
    //   name: "/qrcode",
    //   component: () => import("../components/shareholder/qrcode.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/fenhongjilu",
    //   name: "fenhongjilu",
    //   component: () => import("../components/shareholder/fenhongjilu.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/gubenxiaofei",
    //   name: "gubenxiaofei",
    //   component: () => import("../components/shareholder/gubenxiaofei.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/tixianjilu",
    //   name: "tixianjilu",
    //   component: () => import("../components/shareholder/tixianjilu.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/bind",
    //   name: "bind",
    //   component: () => import("../components/bind.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },
    // {
    //   path: "/nothing",
    //   name: "nothing",
    //   component: () => import("../components/nothing.vue"),
    //   meta: {
    //     auth: true
    //   }
    // },

    
  ]
});

route.beforeEach((to, from, next) => {
  //from 是当前路由 to 是准备进入的路由
  let token = window.sessionStorage.getItem("token");

  let fid = getUrlCode('fid') || ''

  if(fid.length > 5) {
    fid = fid.split('?')[0]
  }

  sessionStorage.setItem("fid", fid);
  
  store.state.fromRoute = from.fullPath

  console.log(to.meta.auth);
  let auth = to.meta.auth;
  // 授权
  if (!token && auth) {
    let code = getUrlCode("code");
    if (!code) {
      //没code，获取appid然后再获取code，调用这个函数会回调当前页面并且带code
      vm.$api.getAppid(location.href);
    } else {
      vm.$api.login(code).then(res => {
        console.log("登录成功");
        if (res === 1) {
          let href = getHref("code", "state");
          window.location.href = href;
        }
      });
    }
    return;
  }

  next();
});

export default route;



// WEBPACK FOOTER //
// ./src/router/index.js